import styled from "styled-components";

export const LiteTradePortfolioEmptyStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    background: #001838;
    background-image: url('${process.env.PUBLIC_URL}/assets/recommended-asset-bg.svg');
    background-size: auto;
    background-position-x: 80%;
    background-position-y: 90%;
    background-repeat: repeat-x;
    border-radius: 16px;
    padding: 16px;

    .col-center {
        flex: 1;
    }
    
    .col-right {
        .btn {
            background: rgba(255, 221, 60, 0.2);
            border-radius: 12px;
            border: none;
            padding: 12px;
            
            svg {
                fill: var(--color-yellow);
            }
        }
    }
    
    .title {
        font-weight: 600;
        font-size: 24px;
    }
    
    .sub-title {
        font-weight: 400;
        font-size: 14px;
        color: var(--color-white-60);
    }
`;
